import LayoutHR from "layouts/layout-hr";
import React from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "utils/constants";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { HR_STAFF_LOAN_VIEW_PERMISSIONS } from "utils/hrPermissionKeys";
import {
  IconCalendarEvent,
  IconCurrencyDollar,
  IconTable,
  // IconCreditCard,
} from "@tabler/icons-react";

const ManagePage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Staff Management & Details",
      description: "View complete staff data grouped by department",
      icon: IconTable,
      path: URLS.v1.HR_MANAGE_STAFF_DETAIL,
      color: "green",
      permissions: ["hr_manage_user"],
    },
    {
      title: "Attendance Hub",
      description: "Pusat pencatatan dan rekap absensi harian karyawan",
      icon: IconCalendarEvent,
      path: URLS.v1.HR_MANAGE_ATTENDANCE,
      color: "info",
      permissions: ["hr_manage_attendance"],
    },
    {
      title: "Public Holiday Hub",
      description: "Pusat pengaturan cuti bersama, alokasi penggunaan, dan rekapitulasi",
      icon: IconCalendarEvent,
      path: URLS.v1.HR_MANAGE_PUBLIC_HOLIDAY_QUOTA,
      color: "success",
      permissions: ["hr_manage_attendance"],
    },
    {
      title: "Salary Management",
      description: "Manage employee salaries and payroll",
      icon: IconCurrencyDollar,
      path: URLS.v1.HR_MANAGE_SALARY,
      color: "warning",
      permissions: ["hr_manage_salary"],
    },
    {
      title: "Staff Loan / Kasbon",
      description: "Kelayakan, pengajuan, cicilan, dan riwayat kasbon staff",
      icon: IconCurrencyDollar,
      path: URLS.v1.HR_MANAGE_STAFF_LOAN,
      color: "orange",
      permissions: HR_STAFF_LOAN_VIEW_PERMISSIONS,
    },

    // {
    //   title: "Transactions",
    //   description: "Manage HR financial transactions and expenses",
    //   icon: IconCreditCard,
    //   path: URLS.v1.HR_MANAGE_TRANSACTIONS,
    //   color: "success",
    // },
  ];

  return (
    <LayoutHR>
      <div className="container-xl">
        {/* Page Header */}
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">HR Management</h2>
              <div className="text-muted mt-1">
                Manage human resources operations
              </div>
            </div>
          </div>
        </div>

        {/* Menu Cards */}
        <div className="row row-deck row-cards">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <PermissionMiddleware key={index} allowedPermissions={item.permissions}>
                <div className="col-sm-6 col-lg-3 mb-4">
                  <div className="card card-hover h-100 d-flex flex-column">
                    <div className="card-body text-center d-flex flex-column">
                      <div
                        className={`avatar avatar-xl mb-3 bg-${item.color}-lt`}
                      >
                        <IconComponent
                          size={32}
                          className={`text-${item.color}`}
                        />
                      </div>
                      <h3 className="card-title mb-2">{item.title}</h3>
                      <p className="text-muted mb-4 flex-grow-1">
                        {item.description}
                      </p>
                      <button
                        className={`btn btn-${item.color} w-100 mt-auto`}
                        onClick={() => navigate(item.path)}
                      >
                        Access 
                        {/* {item.title} */}
                      </button>
                    </div>
                  </div>
                </div>
              </PermissionMiddleware>
            );
          })}
        </div>
      </div>
    </LayoutHR>
  );
};

export default ManagePage;
